import * as actionTypes from './actionTypes';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';
import { DetailModel } from '@app/src/views/CipReport/report/models/Detail';

interface State {
  data: DetailModel;
  isFetching: boolean;
  errorMessage: string;
  selected: number;
}

const initialState = {
  data: {
    code: null,
    message: '',
    detail: [],
    page: {
      total: null,
      current: null,
      totalRow: null
    }
  },
  isFetching: false,
  errorMessage: '',
  selected: null
};

export const detail = (state: State = initialState, action): State => {
  switch(action.type) {
    case actionTypes.FETCH_DETAIL_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: ''
      };
    case actionTypes.FETCH_DETAIL_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.errorMessage
      };
    case actionTypes.FETCH_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        errorMessage: ''
      };
    case actionTypes.SELECTED_ITEM_DETAIL:
      return {
        ...state,
        selected: action.index
      }
    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
};
